'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('project-list', {
      url: '/project/list',
      template: '<project-list></project-list>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/project/list/project-list.routes.js